module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "title"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('strong', [_c('em', [_vm._v("The Marquis de Sade")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('em', [_vm._v("The 120 Days of Sodom and other writings")])]), _vm._v(" "), _c('p', {
    staticClass: "edition"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COMPILED AND TRANSLATED BY")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTRYN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINHOUSE")]), _vm._v(" & R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAVER")])]), _vm._v(" "), _c('p', {
    staticClass: "edition"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WITH INTRODUCTIONS BY")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMONE DE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAUVOIR")]), _vm._v(" & P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IERRE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOSSOWSKI")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 69
// module chunks = 0